import React, { useContext, useMemo } from 'react';

import { datasetsHaveNoData } from '../../utils/chart_utils/chart_utils';
import getMaxValueAcrossDatasets from './helpers/useMaxValueInDataset';

// Chart Context is used to distribute important chart data throughout various parts of a single
// chart component without forcing a prop spreading pattern at the top level.
// This also makes re renders more efficient, and encapsulates configuration logic
const ChartContext = React.createContext({
  chartID: null,
  chartType: 'line',
  datasets: [],
  labels: [],
  dropdownOptions: [],
  noDataAvailable: true,
  units: null,
  maxY: 0,
})

export const ChartProvider = ({
  children,
  options = {},
  chartID = null,
  chartType = 'line',
  datasets: rawDatasets = [],
  dropdownOptions = [],
  units = null,
  prepareDataset = dataset => dataset,
  usePaddedMax = false,
}) => {
  const datasets = useMemo(() => rawDatasets.map(prepareDataset), [prepareDataset, rawDatasets]);
  const noDataAvailable = useMemo(() => datasetsHaveNoData(datasets), [datasets]);

  const maxY = useMemo(() => getMaxValueAcrossDatasets(datasets, usePaddedMax), [datasets, usePaddedMax]);

  const value = useMemo(() => ({
    chartID,
    chartType,
    datasets,
    dropdownOptions,
    noDataAvailable,
    units,
    maxY,
    options,
  }), [
    chartID,
    chartType,
    datasets,
    dropdownOptions,
    noDataAvailable,
    units,
    maxY,
    options
  ]);

  return (
    <ChartContext.Provider
      value={value}
    >
      { children }
    </ChartContext.Provider>
  )
}

export const useChartData = () => useContext(ChartContext);

export default useChartData;
